/* @ngInject */
function ArchivedTasksController ($scope, $rootScope, $location, $timeout, $q, BoardsService, ArchivedTasksService, TasksService, UdsModalService) {
  const getRequestDetailsDialogController = () => $q.when(import('../../dialogs/request-details/request-details-dialog.controller'))
  const getSubtaskDetailsDialogController = () => $q.when(import('../../dialogs/subtask-details/subtask-details-dialog.controller'))
  $scope.showLoadMore = false
  $scope.archivedTasks = []
  $scope.selectedOrder = {
    name: null,
    order: 'DESC'
  }
  $scope.flags = {
    loadingMoreArchived: false,
    loadingArchived: false
  }

  const top = 10
  let skip = 0
  let boardId
  let lastSearchTerm = ''

  const api = {
    activate,
    _successGetTasks,
    _searchTasks,
    _openRequestDetailDialog,
    _openSubtaskDetailDialog,
    getRequestDetailsDialogController,
    getSubtaskDetailsDialogController
  }
  this.getApi = () => api

  function activate () {
    skip = 0
    const url = $location.search()

    $timeout(() => {
      $('.archived-tasks-sort-dropdown').dropdown()
    }, 100, false)

    if (url.board && $rootScope.isUserSysAdminAdminDesigner()) {
      boardId = url.board
      BoardsService.getArchivedTasks(boardId, top, null, null, null).then(api._successGetTasks)
    } else {
      TasksService.getArchivedTasks(top, null, null, null).then(api._successGetTasks)
    }
  }

  const deregisterOpenArchivedTasks = $scope.$on('open-archived-tasks', () => {
    api.activate()
  })

  const deregisterTaskUnarchived = $rootScope.$on('task-unarchived', (event, taskId) => {
    const indexToRemove = $scope.archivedTasks.findIndex(task => task.id === taskId)
    $scope.archivedTasks.splice(indexToRemove, 1)
  })

  const deregisterCloseArchivedTasks = $scope.$on('close-archived-tasks', () => {
    $scope.archivedTasks = []
    $scope.count = undefined
    boardId = null
  })

  $scope.$on('$destroy', () => {
    deregisterOpenArchivedTasks()
    deregisterTaskUnarchived()
    deregisterCloseArchivedTasks()
  })

  $scope.openTaskDetails = function (task) {
    const { id } = task

    if (task.originType === 'SUBTASK') {
      api._openSubtaskDetailDialog(id)
      return
    }

    api._openRequestDetailDialog(id)
  }

  function _openSubtaskDetailDialog (id) {
    TasksService.getTaskById(id).then((subtask) => {
      api.getSubtaskDetailsDialogController().then(({ SubtaskDetailsDialogController }) => {
        const modal = UdsModalService.createModal({
          controller: SubtaskDetailsDialogController,
          modalName: 'subtaskDetailsDialog',
          data: {
            subtask: subtask
          }
        })

        modal.open()
      })
    })
  }

  function _openRequestDetailDialog (id) {
    api.getRequestDetailsDialogController().then(({ RequestDetailsDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: RequestDetailsDialogController,
        modalName: 'requestDetailsDialog',
        data: {
          id
        }
      })
      modal.open()
    })
  }

  $scope.closeArchivedTasks = function () {
    ArchivedTasksService.close()
  }

  $scope.onKeydownImageSearch = function ($event) {
    if ($event.keyCode === 13) {
      api._searchTasks()
    }
  }

  $scope.loadMore = function () {
    $scope.flags.loadingMoreArchived = true
    if (boardId && $rootScope.isUserSysAdminAdminDesigner()) {
      BoardsService.getArchivedTasks(boardId, top, skip, $scope.selectedOrder, lastSearchTerm).then(api._successGetTasks)
    } else {
      TasksService.getArchivedTasks(top, skip, $scope.selectedOrder, lastSearchTerm).then(api._successGetTasks)
    }
  }

  $scope.changeSortOption = function (option) {
    $scope.selectedOrder.order = 'DESC'

    if (option === 'title') {
      $scope.selectedOrder.order = 'ASC'
    }

    if ($scope.selectedOrder.name === option) {
      $scope.selectedOrder.name = null
    } else {
      $scope.selectedOrder.name = option
    }

    skip = 0

    if (boardId && $rootScope.isUserSysAdminAdminDesigner()) {
      BoardsService.getArchivedTasks(boardId, top, skip, $scope.selectedOrder, lastSearchTerm).then(tasks => api._successGetTasks(tasks, true))
    } else {
      TasksService.getArchivedTasks(top, skip, $scope.selectedOrder, lastSearchTerm).then(tasks => api._successGetTasks(tasks, true))
    }
  }

  function _successGetTasks (tasks, reset) {
    if (reset) {
      $scope.archivedTasks = []
      $scope.count = undefined
    }

    tasks.rows.forEach(task => {
      task.isArchived = true
      $scope.archivedTasks.push(task)
    })
    $scope.count = tasks.count
    skip = skip + top

    if ($scope.archivedTasks.length < tasks.count) {
      $scope.showLoadMore = true
    } else {
      $scope.showLoadMore = false
    }

    $scope.flags.loadingArchived = false
    $scope.flags.loadingMoreArchived = false
  }

  function _searchTasks () {
    if ($scope.searchTerm === lastSearchTerm) {
      return
    }

    skip = 0
    lastSearchTerm = $scope.searchTerm

    if (boardId && $rootScope.isUserSysAdminAdminDesigner()) {
      BoardsService.getArchivedTasks(boardId, top, skip, $scope.selectedOrder, $scope.searchTerm).then(tasks => api._successGetTasks(tasks, true))
    } else {
      TasksService.getArchivedTasks(top, skip, $scope.selectedOrder, $scope.searchTerm).then(tasks => api._successGetTasks(tasks, true))
    }
  }
}

export { ArchivedTasksController }
